<template>
  <div v-if="text && text.length" class="StyledText" :class="{ 'StyledText--light': light }" v-html="text"></div>
</template>

<script>
export default {
  props: {
    text: String,
    light: Boolean
  }
}
</script>

<style lang="scss">
.StyledText {
  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      position: relative;
      padding-left: 3em;
      margin-bottom: .5em;
      line-height: 1.7;

      &:last-child {
        margin-bottom: 0;
      }

      &:before {
        content: ' ';
        position: absolute;
        left: .1em;
        top: .4em;
        width: 1em;
        height: .5em;
        border-left: 2px solid var(--colorBrand);
        border-bottom: 2px solid var(--colorBrand);
        transform: rotate(-45deg);
      }
    }
  }

  p {
    font-weight: 700;
    font-size: var(--textSm);
    line-height: 1.5;
  }

  &--light {
    p {
      font-weight: initial;
    }
  }

  .ConfEntry-field & {
    margin-top: .5em;
  }
}
</style>